<template>
  <div class="Drop-Menu">
    <div class=" Drop-Menu__item">
      <LinkProfile @close="sendEmitClose" />
    </div>
    <div class="Drop-Menu__item Drop-Menu__item--color-theme">
      <ColorThemeButton />
    </div>
    <div class="Drop-Menu__item">
      <LinkKnowledgeBase @close="sendEmitClose" />
    </div>
    <div class="Drop-Menu__item" v-if="!isPaid">
      <ActiveGiftCode @close="sendEmitClose" />
    </div>
    <div class="Drop-Menu__item" v-if="get_isModerator">
      <LinkPolymarket @close="sendEmitClose" />
    </div>
    <div class="Drop-Menu__item" v-if="showPushNotifications">
      <PushNotifications />
    </div>
    <div class="Drop-Menu__item">
      <LogoutBtn @close="sendEmitClose" />
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  //------------------------------------
  import LinkProfile from './items/LinkProfile/LinkProfile';
  import PushNotifications from './items/PushNotifications/PushNotifications.vue';
  import LogoutBtn from './items/Logout/LogoutBtn';
  import ActiveGiftCode from './items/ActiveGiftCode/ActiveGiftCode.vue';
  import LinkKnowledgeBase from './items/LinkKnowledgeBase/LinkKnowledgeBase.vue';
  import LinkPolymarket from './items/LinkPolymarket/LinkPolymarket.vue';
  import ColorThemeButton from '@/Groups/ColorThemesManager/public/modules/ColorThemeButton/ColorThemeButton.vue';
  //------------------------------------
  const emit = defineEmits(['close']);
  const store = useStore();
  //------------------------------------
  const get_isModerator = computed(() => store.getters['UserSystem/hasModeratorPrivileges']);
  //Оплачен ли аккаунт у пользователя
  const isPaid = computed(() => store.getters['UserSystem/hasPaidAccess']);
  //------------------------------------
  //Отправляем событие закрытие дропдауна
  const sendEmitClose = () => emit('close');
  //------------------------------------
  function isMobile() {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
  }
  function isPWA() {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    );
  }
  const showPushNotifications = computed(() => isMobile() && isPWA());
</script>

<style lang="scss">
  @import "../../styles/Drop-Menu";
</style>
